// Phone number formatting utility
export const formatPhoneNumber = (phone) => {
  if (!phone) return '';
  
  // Remove all non-digit characters
  const cleaned = phone.replace(/\D/g, '');
  
  // Format as (XXX) XXX-XXXX
  if (cleaned.length === 10) {
    return `(${cleaned.slice(0, 3)}) ${cleaned.slice(3, 6)}-${cleaned.slice(6)}`;
  }
  
  // If 11 digits and starts with 1, remove the 1
  if (cleaned.length === 11 && cleaned[0] === '1') {
    return formatPhoneNumber(cleaned.slice(1));
  }
  
  // Return as-is if not standard format
  return phone;
};

// Currency formatting
export const formatCurrency = (amount) => {
  if (!amount || amount === '0.00') return '$0.00';
  const num = parseFloat(amount);
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD'
  }).format(num);
};
